require('./cardDetailsView.scss');
const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @actions
const cardChangePaymentMethodActions = require('actions/cardChangePaymentMethod');
const { getECardInformation } = require('actions/eCardInformation');
const { getCardSecurePaymentConfiguration } = require('actions/cardSecurePayment');
const { getCreditCardPayLaterOptedInfo } = require('actions/creditCardPayLaterInfo')
const cardDataActions = require('actions/contactCenter/cardData');
const creditCardRenewalInfoActions = require('actions/contactCenter/creditCardRenewalInfo');
const { requestLatestCardHistory } = require('actions/contactCenter/latestCardHistory/latestCardHistory');
const collectivesActions = require('actions/collectives');
const switchTravelPlusActions = require('actions/cardTravel');
const hireTravelPlusActions = require('actions/hireTravelPlus');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @components
const CardMoreOptionsButton = require('components/cards/cardMoreOptionsButton/cardMoreOptionsButton');
const CardContract = require('components/cards/cardDetails/cardContract/cardContract');
const CardDetailsSidebar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardBilling = require('components/cards/cardDetails/cardBilling/cardBilling');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardAdditionalBeneficiaries = require('components/cards/cardDetails/cardAdditionalBeneficiaries/cardAdditionalBeneficiaries');
const CardOperatingLimit = require('components/cards/cardDetails/CardOperatingLimit/CardOperatingLimit.js');
const CardPrepaidBalance = require('components/cards/cardDetails/cardPrepaidBalance/cardPrepaidBalance');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const WebappRender = require('components/conditionalRender/webappRender')
const LatestCardHistory = require('components/contactCenter/cards/cardDetails/latestCardHistory/latestCardHistory')
const AssociatedCards = require('components/contactCenter/cards/cardDetails/associatedCards/associatedCards')
const CardDetailsTravelPlus = require('components/cards/cardDetails/cardDetailsTravelPlus/cardDetailsTravelPlus');
// @utilities
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');

// @helpers
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { contactCenterClassName, conditionalClassName } = require('utilities/conditionals/conditionalClassname')

// @constants
const { CARD_CREDIT, CARD_INTERVENTION_OWNER, CARD_DEBIT, CARD_ECARD } = require('constants/index');
const { PRODUCT_HIRED_DETAILS_COMPONENT_ID } = require('constants/hiringProductInformation');
const { TRAVEL_PLUS_R42 } = require('constants/flagBasedFeatures');

class CardDetailsView extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.resize = this.resize.bind(this);

        this.state = {
            parentWidth: window.innerWidth
        };
    }

    componentWillMount() {
        if (__CONTACT_CENTER__) {
            const { requestCardData, immCards, match: { params: { cardId } } } = this.props;
            const immCard = immCards.get('byId').get(cardId);
            requestCardData(immCard)
        }
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } }, flagBasedFeatures, immProfile } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const type = immCard.get('type');

        AccessHelper.allowAccess(cardConstants.CARD_DETAILS, { immCard }, history);

        if (type === CARD_CREDIT) {
            this.props.requestPaymentMethodInfo(cardId);
        }

        if (type === CARD_CREDIT && cardValidationRules.CARD_PAY_LATER.validator({ immCard })) {
            this.props.getCreditCardPayLaterOptedInfo(immCard);
        }
        // When we have an eCard, we ask for the eCard information to another
        // service, so we need to know that we are consulting a eCard.

        if (type === CARD_ECARD) {
            this.props.getECardInformation(cardId);
        } else if (__CONTACT_CENTER__) {
            const { getCreditCardRenewalDetails } = this.props
            getCreditCardRenewalDetails(cardId);
        }

        if (__CONTACT_CENTER__) {
            const { requestLatestCardHistory } = this.props;
            requestLatestCardHistory(immCard.get('number'), immCard.getIn(['contract', 'product']), immCard.getIn(['contract', 'number']));
        }

        if (immProfile.get('isCollective') && flagBasedFeatures.get('collectivos-enabled')) {
            const immProduct = immCard.get('product');
            const product = {
                type: immProduct.get('type'),
                subType: immProduct.get('subtype'),
                standard: immProduct.get('standard')
            };
            this.props.getCollectiveInfo([product], PRODUCT_HIRED_DETAILS_COMPONENT_ID, true);
        }

        this.props.getCardSecurePaymentConfiguration(immCard);

        window.addEventListener('resize', this.resize);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/detalle', PAGE_GENERIC, '', '', tagging);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    resize() {
        this.setState({
            parentWidth: window.innerWidth
        });
    }

    render() {
        const {
            match: { params: { cardId } },
            hireTravelPlusCCWrapUpOffStart,
            hireTravelPlusCCWrapUpOnStart,
            immCards,
            immCardCharge,
            immCardChangePaymentMethod,
            immCardSecurePayment,
            immCCPayLaterInfo,
            immGlobalVariables,
            immScreen,
            immSignaturePattern,
            immTravelPlus,
            immProfile,
            flagBasedFeatures,
            immCardData,
            immCancelCardPayLater,
            immLatestCardHistory,
            immCreditCardRenewalStatus,
            setCardTravelPlus,
            setTravelPlus,
            travelPlusReset,
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        let content;
        const travelSwitchVisible = immCard.getIn(['r42', 'travelSwitchVisible']);
        
        if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const interventionType = immCard.get('interventionType');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: type === CARD_DEBIT ? formatText('cardDetails-cardDetails_titleDebitCards') : formatText('cardDetails-title'),
                    url: ''
                }
            ];

            let beneficiariesBlock;
            let billingBlock;
            let operatingLimitBlock;
            let prepaidBalanceBlock;
            let travelPlusBlock;

            if (immCard.get('hasBeneficiaries')
                && type === CARD_CREDIT
                && interventionType === CARD_INTERVENTION_OWNER
                && !__CONTACT_CENTER__) {
                beneficiariesBlock = <CardAdditionalBeneficiaries immCard={immCard} />;
            }

            if (type === CARD_CREDIT) {
                billingBlock = (
                    <CardBilling
                        immCard={immCard}
                        cardId={cardId}
                        isCardCancelPayLaterEnabled={flagBasedFeatures.get('card-cancel-pay-later-enabled')}
                        immCardChangePaymentMethod={immCardChangePaymentMethod}
                        immPayLaterInfo={immCCPayLaterInfo}
                        flagBasedFeatures={flagBasedFeatures}
                    />
                );
            }

            if (type === CARD_DEBIT) {
                operatingLimitBlock = <CardOperatingLimit immCard={immCard} />;
            }

            if (travelSwitchVisible ) {
                 travelPlusBlock = (
                    <CardDetailsTravelPlus
                        hireTravelPlusCCWrapUpOffStart={hireTravelPlusCCWrapUpOffStart}
                        hireTravelPlusCCWrapUpOnStart={hireTravelPlusCCWrapUpOnStart}
                        immCard={immCard}
                        immGlobalVariables={immGlobalVariables}
                        immSignaturePattern={immSignaturePattern}
                        immTravelPlus={immTravelPlus}
                        setTravelPlus={setTravelPlus}
                        setCardTravelPlus={setCardTravelPlus}
                        travelPlusReset={travelPlusReset}
                        flagBasedFeatures={flagBasedFeatures}

                    />
                );
            }

            if (type == CARD_ECARD || immCard.get('isOpenYoung')) {
                prepaidBalanceBlock = (
                    <CardPrepaidBalance
                        immCard={immCard}
                        loading={immCardCharge.get('isFetching')}
                    />
                );
            }


            const cardMoreOptionsButton = (
                <CardMoreOptionsButton
                    cardId={cardId}
                    flagBasedFeatures={flagBasedFeatures}
                    immCard={immCard}
                    immCancelCardPayLater={__CONTACT_CENTER__ ? immCancelCardPayLater : undefined}
                />
            );

            let cardMoreOptionsButtonMobile;
            let cardMoreOptionsButtonDesktop;

            if (immScreen.get('isMobile')) {
                cardMoreOptionsButtonMobile = cardMoreOptionsButton;
            } else {
                cardMoreOptionsButtonDesktop = cardMoreOptionsButton;
            }

            const cardDetailsClassName = contactCenterClassName('card-details')
            const cardDetailsBodyClassName = contactCenterClassName('card-details__body', 'grid-view__body')
            const cardDetailsContainerClassName = contactCenterClassName('card-details__container', 'container-fluid')
            const fixCellSeparationBottonClassName = contactCenterClassName('grid-view--fix-cell-separation-bottom', 'col-md-12')
            const cardDetailsSidebarClassName = conditionalClassName(
                'hidden-md',
                'card-details__sidebar',
                'hidden-xs hidden-sm col-lg-12 grid-view--fix-cell-separation-bottom'
            )

            let commercialAdsContent;

            if (!immProfile.get('isNerudaUser')) {
                commercialAdsContent = (
                    <div className="col-xs-12 grid-view--variable-cell-separation">
                        <CommercialAds
                            path="cards/:cardId/details"
                            type="banner-b"
                        />
                    </div>
                );
            }

            content = (
                <div className={cardDetailsClassName}>
                    <div className="container-fluid card-details--header-identifier">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={type === CARD_DEBIT ? getFinalTitle('cardDetails-cardDetails_titleDebitCards') : getFinalTitle('cardDetails-title')}
                                >
                                    <div>
                                        {cardMoreOptionsButtonMobile}
                                        <CardHeaderDetails
                                            immCard={immCard}
                                            rightSpace={true}
                                        />
                                        {cardMoreOptionsButtonDesktop}
                                    </div>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={cardDetailsBodyClassName}>
                        <div className={cardDetailsContainerClassName}>
                            <div className="row grid-view--content-position-negative">
                                {/* >> CONTENT DUPLICATED: REF-01 */}
                                <WebappRender>
                                    <div className="col-xs-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                        <CardDetailsSidebar
                                            immCard={immCard}
                                            immCardSecurePayment={immCardSecurePayment}
                                            immCardRenewalStatus={__CONTACT_CENTER__ ? immCreditCardRenewalStatus : undefined}
                                        />
                                    </div>
                                </WebappRender>
                                {/* CONTENT DUPLICATED: REF-01 << */}
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className={fixCellSeparationBottonClassName}>
                                            <OKSectionBox>
                                                <CardContract
                                                    immCard={immCard}
                                                    cardId={cardId}
                                                    immFlagBasedFeatures={flagBasedFeatures}
                                                    immProfile={immProfile}
                                                />
                                                {operatingLimitBlock}
                                                {billingBlock}
                                                <ContactCenterRender>
                                                    <AssociatedCards immCard={immCard} immCards={immCards} />
                                                </ContactCenterRender>
                                                {prepaidBalanceBlock}
                                                {beneficiariesBlock}
                                                {travelPlusBlock}
                                            </OKSectionBox>
                                        </div>
                                        <ContactCenterRender>
                                            <div className="col-md-12">
                                                <OKSectionBox>
                                                    <LatestCardHistory
                                                        immLatestCardHistory={immLatestCardHistory}
                                                        immCard={immCard}
                                                    />
                                                </OKSectionBox>
                                            </div>
                                        </ContactCenterRender>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">
                                        {/* >> REF-01 */}
                                        <div className={cardDetailsSidebarClassName}>
                                            <CardDetailsSidebar
                                                immCardData={__CONTACT_CENTER__ ? immCardData : undefined}
                                                immCard={immCard}
                                                immCardSecurePayment={immCardSecurePayment}
                                                immLatestCardHistory={__CONTACT_CENTER__ ? immLatestCardHistory : undefined}
                                                immCardRenewalStatus={__CONTACT_CENTER__ ? immCreditCardRenewalStatus : undefined}
                                            />
                                        </div>
                                        {/* REF-01 << */}
                                        {commercialAdsContent}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

CardDetailsView.propTypes = {
    hireTravelPlusCCWrapUpOffStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immCardData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immCCPayLaterInfo: PropTypes.object.isRequired,
    immCardChangePaymentMethod: PropTypes.object.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    immCardSecurePayment: PropTypes.object.isRequired,
    immCreditCardRenewalStatus: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    getECardInformation: PropTypes.func.isRequired,
    getCardSecurePaymentConfiguration: PropTypes.func.isRequired,
    getCreditCardPayLaterOptedInfo: PropTypes.func.isRequired,
    getCollectiveInfo: PropTypes.func.isRequired,
    requestPaymentMethodInfo: PropTypes.func.isRequired,
    getCreditCardRenewalDetails: PropTypes.func.isRequired,
    requestLatestCardHistory: PropTypes.func.isRequired,
    requestCardData: PropTypes.func.isRequired,
    immLatestCardHistory: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object,
    setCardTravelPlus: PropTypes.func.isRequired,
    setTravelPlus: PropTypes.func.isRequired,
    travelPlusReset: PropTypes.func.isRequired,
};

module.exports.constructor = CardDetailsView;
module.exports.CardDetailsView = connect(
    state => ({
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immCardData: state.cardData,
        immCardSecurePayment: state.cardSecurePayment,
        immGlobalVariables: state.globalVariables,
        immProfile: state.profile,
        immCardChangePaymentMethod: state.cardChangePaymentMethod,
        immCCPayLaterInfo: state.creditCardPayLaterInfo,
        immCancelCardPayLater: state.cancelCardPayLater,
        immLatestCardHistory: state.latestCardHistory,
        immCreditCardRenewalStatus: state.cancelCreditCardRenewal,
        immScreen: state.screen,
        immSignaturePattern: state.signaturePattern,
        immTravelPlus: state.hireTravelPlus,
        flagBasedFeatures: state.flagBasedFeatures
    }),
    {
        hireTravelPlusCCWrapUpOffStart: hireTravelPlusActions.hireTravelPlusCCWrapUpOffStart,
        hireTravelPlusCCWrapUpOnStart: hireTravelPlusActions.hireTravelPlusCCWrapUpOnStart,
        getECardInformation: getECardInformation,
        requestCardData: cardDataActions.requestCardData,
        requestLatestCardHistory: requestLatestCardHistory,
        getCreditCardRenewalDetails: creditCardRenewalInfoActions.getCreditCardRenewalDetails,
        getCardSecurePaymentConfiguration: getCardSecurePaymentConfiguration,
        getCreditCardPayLaterOptedInfo: getCreditCardPayLaterOptedInfo,
        requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo,
        getCollectiveInfo: collectivesActions.getCollectiveInfo,
        setCardTravelPlus: switchTravelPlusActions.setCardTravelPlus,
        setTravelPlus: hireTravelPlusActions.setTravelPlusWithSignaturePattern,
        travelPlusReset: hireTravelPlusActions.reset,
    }
)(withRouter(CardDetailsView));
